angular.module('clientDashboardApp').directive('validPhone', function (){
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attr, ngModel) {
      ngModel.$parsers.unshift(function(value) {
        var valid = value.length == 0 || value.replace(/[^0-9]/g, '').match(/\d{10,13}/) != null;
        ngModel.$setValidity('validPhone', valid);
        return valid ? value : undefined;
      });
    }
  };
});
